/**
 * Avoid using `APP_MESSAGE` directly, please
 * use `useAppMessages()` hook instead.
 */
export const APP_MESSAGE = {
  error: {
    unknown: 'Something went wrong, please try again.',
    notSaved: 'Something went wrong and your change could not be saved.',
    customer: {
      notFound: 'Customer not found.',
    },
    service: {
      notFound: 'Service not found.',
    },
    appointment: {
      update: 'There has been an error while updating an appointment',
      create: 'There has been an error while creating an appointment',
    },
    job: {
      update: 'There has been an error while updating a job',
    },
    accounting: {
      widgetUnknown: 'Failed to fetch data. Try again by clicking the button below.',
      widgetRefresh: 'Refresh',
      unknown: 'Failed to fetch data. Refresh the page to try again.',
      refresh: 'Refresh Page',
      reloadPage: 'Reload Page',
      magicLink: "Couldn't generate the link. Please try again.",
      notification: 'Failed to fetch notifications.',
      retry: 'Retry',
      reports: "Couldn't download the file.",
    },
    bookingInfo: {
      notFound: 'Booking settings not found.',
      tags: 'Failed to fetch booking tags',
      unknown: 'Something went wrong with booking settings, please try again.',
    },
    earliestAvailability: {
      notFound: 'Earliest availability settings not found',
      update: 'There has been an error while updating earliest availability settings',
    },
    charging: {
      retryChargeFailed: 'There was an error while trying to retry this charge',
      discardDelayedRetryFailed: 'There was an error while trying to discard delayed retry',
      cardChargeFailed: 'There was an error while trying to charge this credit card',
      orgIdRequiredForCharges: 'Organization id is required for fetching charges',
      setCardAsPrimaryFailed: 'There was an error while trying to set this credit card as primary.',
      updateCardFailed: 'There was an error while trying to update this credit card.',
      deleteCreditCardFailed: 'There was an error while trying to remove this credit card.',
      addCreditCardFailed: 'There was an error while trying to add new credit card.',
    },
    billing: {
      accountSuspendedStatus: 'There was an error while trying to verify that you account is not suspended',
      subscriptionTransitionDeleteFailed: 'There was an error while trying to delete product subscription transition',
    },
    trials: {
      orgIdRequiredForTrialss: 'Organization id is required for fetching trials',
      trialStartError: 'There was an error while tying to start this trial',
    },
    payroll: {
      couldNotLoadComponent: "Couldn't load Payroll component.",
      couldNotFindToken: "Couldn't find token for Payroll employee/contractor self-onboarding.",
      couldNotAppendCheckComponent: "Couldn't append Check Component to component holder.",
      orgIdRequired: 'Organization id is missing',
      couldNotCreateHCPEmployee: 'Could not create HCP user please try again or reach out to us through support chat',
      internalError: 'An internal error occurred. We are looking into the issue.',
      couldNotCopyPaystubsLink: "Couldn't copy paystubs link. Please select the link and copy it.",
      couldNotCopyOnboardingLink: "Couldn't copy onboarding link. Please select the link and copy it.",
    },
    checkDeposit: {
      notFound: 'Check deposit not found.',
    },
    productPayWall: {
      productPayWallDeleteFailed: 'There was an error while trying to remove this product subscription.',
      productPayWallUpdateFailed: 'There was an error while trying to update this product subscription.',
    },
    reporting: {
      errorMax: 'Max amount must be greater than min amount.',
    },
  },
  success: {
    charging: {
      retryChargeSuccess: 'Retry charge successful',
      discardDelayedRetrySuccess: 'Delayed retry has been successfully discarded',
      cardChargeSuccess: 'Credit card was successfully charged',
      setCardAsPrimarySuccess: 'Credit card has been successfully set as primary.',
      deleteCreditCardSuccess: 'Credit card has been succesfully removed.',
    },
    trials: {
      trialStartSuccess: 'Trial has been successfully started',
    },
    appointment: {
      createSuccess: 'Appointment created successfully',
      updateSuccess: 'Appointment has been updated',
    },
    payroll: {
      employeeCreateSuccess: 'Employee created successfully',
      employeeUpdateSuccess: 'Employee updated successfully',
      copyPaystubsLink: 'Paystubs link copied to clipboard.',
      copyOnboardingLink: 'Onboarding link copied to clipboard.',
    },
    productPayWall: {
      productPayWallDeleteSuccess: 'Product subscription has been removed successfully.',
      productPayWallUpdateSuccess: 'Product subscription has been successfully updated.',
    },
    accounting: {
      joinedWaitlist: 'Thanks for joining the waitlist! Our team will reach out to you shortly for a demo!',
    },
  },
} as const;
